import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { SimpleTreeView } from '@mui/x-tree-view';
import { SearchField } from 'console/shared/components/fields/search';
import { ObjectItem } from './item';
import { searchInZ3kConfig } from '../utils';
import { Box, styled } from '@mui/material';
const StyledTreeView = styled(SimpleTreeView)(({ theme }) => ({
    flexGrow: 1,
    [theme.breakpoints.only('xs')]: {
        maxWidth: 300,
    },
    [theme.breakpoints.only('sm')]: {
        maxWidth: 400,
    },
    [theme.breakpoints.up('sm')]: {
        maxWidth: 800,
    },
    [theme.breakpoints.up('lg')]: {
        maxWidth: 1080,
    },
}));
export function RenderZ3KConfig(props) {
    const { z3kConfig, z3kState, viewSearch = true } = props;
    const [temp_config, setTempConfig] = useState(z3kConfig);
    useEffect(() => {
        setTempConfig(z3kConfig);
    }, [z3kConfig]);
    const [expanded, setExpanded] = useState([]);
    const [selected, setSelected] = useState([]);
    const handleToggle = useCallback((event, nodeIds) => {
        setExpanded(nodeIds);
    }, []);
    const handleSelect = useCallback((event, nodeIds) => {
        if (nodeIds == null) {
            setSelected([]);
            return;
        }
        if (typeof nodeIds === 'string') {
            setSelected([nodeIds]);
            return;
        }
        setSelected(nodeIds);
    }, []);
    const [search_value, setSearchValue] = useState('');
    const onSearch = useCallback((value) => {
        const mini_search_value = value.toLowerCase().trim();
        setSearchValue(value);
        if (temp_config == null) {
            return;
        }
        const found = searchInZ3kConfig(z3kConfig, mini_search_value);
        setTempConfig(Object.fromEntries(found.sort()));
    }, [setSearchValue, temp_config, z3kConfig, setTempConfig]);
    const onClearSearch = useCallback(() => {
        setSearchValue('');
        setTempConfig(z3kConfig);
    }, [setSearchValue, setTempConfig, z3kConfig]);
    return z3kConfig == null ? null : (_jsxs(Box, { display: "flex", flexDirection: "column", gap: 2, children: [viewSearch && (_jsx(SearchField, { value: search_value, onChange: onSearch, onClear: onClearSearch, placeholder: "\u041F\u043E\u0438\u0441\u043A" })), _jsx(StyledTreeView, { expandedItems: expanded, selectedItems: selected, onExpandedItemsChange: handleToggle, onSelectedItemsChange: handleSelect, multiSelect: true, children: temp_config != null
                    ? Object.entries(temp_config)
                        .sort()
                        .map(([key, value]) => (_jsx(ObjectItem, { name: key, value: value, z3kState: z3kState ?? {}, z3kConfig: z3kConfig }, key)))
                    : null })] }));
}
